
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cohorts/[slug]",
      function () {
        return require("private-next-pages/cohorts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cohorts/[slug]"])
      });
    }
  